export default "__VITE_ASSET__39406374__"